import OrbitAvatar from '@/components/OrbitAvatar'
import { editTask } from '@/services/task/task'
import { UserOutlined } from '@ant-design/icons'
import { Avatar, Select, Space } from 'antd'
import { memo, useEffect, useMemo, useState } from 'react'
import styles from './index.module.less'

export default memo(function TaskAssign(props: any) {
  const { task, members, editable = true, onSuccess } = props
  const [editing, setEditing] = useState(props.editing || false)
  const [value, setValue] = useState<any>()
  const member = useMemo(() => members.find((member) => member.memberId === value), [members, value])

  useEffect(() => {
    const target = task.assignees?.[0]
    if (target) {
      setValue(target.memberId)
    }
  }, [task])

  const handleChange = async (newValue) => {
    if (newValue) {
      const data = await editTask(task.id, { assignees: [newValue] })
      onSuccess?.(data)
      setEditing(false)
      setValue(newValue)
    } else {
      setEditing(false)
    }
  }

  if (editing) {
    return (
      <Select
        className='w100'
        autoFocus
        value={value}
        onChange={(newValue) => {
          handleChange(newValue)
        }}
        onBlur={() => {
          setEditing(false)
        }}
        open={true}
      >
        {members.map((member) => (
          <Select.Option key={member.memberId} value={member.memberId}>
            <Space>
              <OrbitAvatar size={24} avatar={member.avatar} name={member.fullName} />
              {member.fullName}
            </Space>
          </Select.Option>
        ))}
      </Select>
    )
  }

  return (
    <div
      className={styles.fieldItem}
      onClick={() => {
        if (editable) {
          setEditing(true)
        }
      }}
    >
      {member ? (
        <Space>
          <OrbitAvatar size={24} avatar={member.avatar} name={member.fullName} />
          {member.fullName}
        </Space>
      ) : (
        <Avatar size={24} icon={<UserOutlined />} />
      )}
    </div>
  )
})
